/**
 * Extracts the ID from the URL path based on the page type.
 * @param path The URL path.
 * @param pageType The type of ID to extract:
 * - `'Product'` — the product ID from a product URL.
 * - `'Category'` — the category ID from a category (`/c/`) URL.
 * - `'ProductCategory'` — the category ID embedded within a product (`/p/`) URL.
 * @returns The ID extracted from the URL path, or an empty string when no match is found.
 * @category Utils
 */
export const getUrlId = (path: string, pageType: 'Product' | 'Category' | 'ProductCategory') => {
  const regexByType = {
    Product: PRODUCT_URL_REGEX,
    Category: CATEGORY_URL_REGEX,
    ProductCategory: PRODUCT_CATEGORY_URL_REGEX,
  }

  return path.match(regexByType[pageType])?.[1] || ''
}
